/*******************************************************************************
 * Copyright (c) 2025 Bula Technologies
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 1.0.0
 *
 *******************************************************************************/

import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import DashboardPage from '../pages/guarded/features/dashboard/DashboardPage'

const MainGuardRoute = () => {
  const navigate = useNavigate()
  const auth = !!window.localStorage.getItem('bulajwt')

  useEffect(() => {
    if (!auth) {
      navigate('/login') // Redirect to login if not authenticated
    }
  }, [auth, navigate])

  return auth ? <DashboardPage /> : null // Return null to prevent rendering issues
}

export default MainGuardRoute
